mutation DeleteSmsDripEdition($input: SmsDripEditionDeleteInput!) {
    smsDripEditionDelete(input: $input) {
        edition {
            id
        }
    }
}
